import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import SnapScan from "app/components/AppComponents/SnapScan/SnapScan";
import GraphiQL from "app/components/AppComponents/GraphiQL";

export default class BOContent extends React.Component<any, any> {
  render() {
    return (
      <div id="BOContent" className={this.props.sideOpen ? "sideOpen" : ""}>
        <Switch>
          <Route
            exact={true}
            path="/"
            render={() => <Redirect to={`/snapscan/ops/payments`} />}
          />

          <Route path="/snapscan" render={() => <SnapScan {...this.props} />} />
          <Route path="/graphiql" render={() => <GraphiQL />} />
        </Switch>
      </div>
    );
  }
}
